import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { ComponentType, enumMapper, FeatureFlag, NotificationState, SeverityType, } from '@models';
import { AlertDetailsModalComponent } from '@pages/alerts/alert.details.modal';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { JobDetailsModalComponent } from '@pages/jobs/modals';
import { TransactionDetailsModalComponent } from '@pages/transactions/modals';
import { AlertsService, JobService, QueueItemService, SignalRService, } from '@services';
import { merge } from 'rxjs';
import { takeUntil, tap, } from 'rxjs/operators';
var ɵ0 = urlStateHandler;
var AlertsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AlertsPageComponent, _super);
    function AlertsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.severityList = enumMapper(SeverityType, {
            resourceKey: 'SeverityType',
        });
        _this.componentsMap = enumMapper(ComponentType, {
            resourceKey: 'ComponentType',
            filter: function (key) { return _this._filterAlertComponent(key); },
        });
        _this.defaultSeverity = _this.severityList
            .find(function (s) { return s.value === SeverityType.Info.toString(); });
        _this.stateList = enumMapper(NotificationState, {
            resourceKey: 'NotificationState',
        });
        _this.defaultState = _this.stateList
            .find(function (s) { return s.value === NotificationState.Unread.toString(); });
        _this._queueItemService = _this._injector.get(QueueItemService);
        _this._jobService = _this._injector.get(JobService);
        _this._signalRService = _this._injector.get(SignalRService);
        _this._alertsService = _this._injector.get(AlertsService);
        _this.classConfig = function (entry) { return ({
            'alert-unread': entry.state === 'Unread',
            'alert-read': entry.state === 'Read',
        }); };
        return _this;
    }
    Object.defineProperty(AlertsPageComponent.prototype, "currentFolderId", {
        get: function () { return this._appState.user.folder.value && this._appState.user.folder.value.id; },
        enumerable: true,
        configurable: true
    });
    AlertsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        merge(this._signalRService.notification$, this._appState.language.change$)
            .pipe(tap(function () { return _this._refresh$.next(); }), takeUntil(this._destroyed$))
            .subscribe();
    };
    AlertsPageComponent.prototype.showDetails = function (alert) {
        var _this = this;
        switch (alert.component) {
            case 'Transactions':
                this._queueItemService
                    .getInstance(alert.data.queueItemId)
                    .pipe(takeUntil(this._destroyed$))
                    .subscribe(function (queueItem) {
                    _this.markAsRead([alert]);
                    _this._modal.openModal(TransactionDetailsModalComponent, queueItem, { size: 'lg', autoFocus: false });
                });
                break;
            case 'Jobs':
                this._jobService
                    .getInstance(alert.data.jobId, ['Robot', 'Release'])
                    .pipe(takeUntil(this._destroyed$))
                    .subscribe(function (job) {
                    _this.markAsRead([alert]);
                    _this._modal.openModal(JobDetailsModalComponent, job);
                });
                break;
            case 'Process':
                this.markAsRead([alert]);
                this._modal.openModal(AlertDetailsModalComponent, alert.data);
                break;
        }
    };
    AlertsPageComponent.prototype.markAsRead = function (alerts) {
        var _this = this;
        if (alerts === void 0) { alerts = this._grid.selectionManager.selected; }
        var alertsPayload = alerts
            .filter(function (a) { return a.state === 'Unread'; })
            .map(function (a) { return a.userNotificationId; });
        if (!alertsPayload.length) {
            return;
        }
        this._alertsService.markAsRead(alertsPayload)
            .pipe(tap(function () { return _this._refresh$.next(); }))
            .subscribe();
    };
    Object.defineProperty(AlertsPageComponent.prototype, "allowMarkAsRead", {
        get: function () {
            return this._grid.selectionManager.hasValue() &&
                this._grid.selectionManager.selected
                    .some(function (a) { return a.state === 'Unread'; });
        },
        enumerable: true,
        configurable: true
    });
    AlertsPageComponent.prototype._filterAlertComponent = function (key) {
        if (!isNaN(Number.parseInt(key, 10))) {
            return false;
        }
        switch (key) {
            case 'Tasks':
                return this._appState.settings.isFeatureEnabled(FeatureFlag.Tasks);
            default:
                return true;
        }
    };
    return AlertsPageComponent;
}(ODataGridComponent));
export { AlertsPageComponent };
export { ɵ0 };
